import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { createElement } from 'react';
import { classNames } from './utils';
export default function ToggleButton({ multi, value, items, size = 'normal', disabled, onChange, }) {
    return (_jsx("span", { className: "isolate inline-flex rounded-md shadow-xs", children: items.map((item, i) => (_jsxs("button", { type: "button", disabled: disabled !== null && disabled !== void 0 ? disabled : item.disabled, className: classNames('relative inline-flex flex-1 items-center justify-center text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 focus:z-10', 'disabled:text-gray-400 disabled:ring-gray-200', {
                'x-small': 'px-2 py-1',
                'small': 'px-2.5 py-1.5',
                'normal': 'px-3 py-2',
                'large': 'px-3.5 py-2.5',
                'x-large': 'px-4 py-3',
            }[size], i === 0 ? 'rounded-l-md' : undefined, i + 1 === items.length ? 'rounded-r-md' : undefined, {
                default: 'text-gray-900 hover:bg-gray-50',
                primary: 'text-indigo-600 hover:bg-indigo-50',
                positive: 'text-green-600 hover:bg-green-50',
                negative: 'text-red-600 hover:bg-red-50',
            }[item.color || 'default'], (multi
                ? value === null || value === void 0 ? void 0 : value.some((v) => v === item.value)
                : value === item.value)
                ? 'bg-gray-100 disabled:bg-gray-200'
                : 'bg-white disabled:bg-gray-50'), onClick: () => {
                if (multi) {
                    const exists = value === null || value === void 0 ? void 0 : value.some((v) => v === item.value);
                    onChange === null || onChange === void 0 ? void 0 : onChange(exists
                        ? [...(value || [])].filter((v) => v !== item.value)
                        : [...(value || []), item.value]);
                }
                else {
                    if (value === item.value)
                        return;
                    onChange === null || onChange === void 0 ? void 0 : onChange(item.value);
                }
            }, children: [item.icon ? (_jsx("span", { className: classNames('h-5 w-5', item.title ? 'me-3' : ''), children: React.isValidElement(item.icon)
                        ? item.icon
                        : createElement(item.icon, {
                            'aria-hidden': 'true',
                        }) })) : undefined, item.title] }, i))) }));
}
